export default {
  methods: {
    getCategory(categoryID) {
      return this.$beet.categories[categoryID] ?? null
    },
  },
}
